import React, { useContext, useRef } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import { FaArrowRight, FaArrowLeft, FaChevronLeft } from 'react-icons/fa';
import { ThemeContext } from '../../contexts/ThemeContext';
import { testimonialsData } from '../../data/testimonialsData';
import './Testimonials.css';

function Testimonials() {
    const { theme } = useContext(ThemeContext);
    const sliderRef = useRef();

    const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        fade: true,
        cssEase: 'ease-in-out',
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        lazyLoad: 'ondemand',
        dotsClass: 'slick-dots hero-dots',
        customPaging: () => <button className="hero-dot-btn" />,
    };

    return (
        <div className="hero-slider">
            <Slider {...settings} ref={sliderRef}>
                {testimonialsData.map((slide) => (
                    <div key={slide.id} className="hero-slide">
                        {/* عکس پس‌زمینه */}
                        <div className="hero-slide__bg">
                            <img
                                src={slide.image}
                                alt={slide.headline}
                                loading="lazy"
                            />
                        </div>

                        {/* لایه gradient */}
                        <div className="hero-slide__overlay" />

                        {/* محتوای متنی */}
                        <div className="hero-slide__content">
                            <span
                                className="hero-slide__tag"
                                style={{ borderColor: theme.primary, color: theme.primary }}
                            >
                                {slide.tag}
                            </span>
                            <h2 className="hero-slide__headline">{slide.headline}</h2>
                            <p className="hero-slide__subtitle">{slide.subtitle}</p>
                            <Link
                                to={slide.link}
                                className="hero-slide__btn"
                                style={{ background: theme.primary }}
                            >
                                مشاهده خدمات <FaChevronLeft size={12} />
                            </Link>
                        </div>
                    </div>
                ))}
            </Slider>

            {/* دکمه‌های ناوبری */}
            <button
                className="hero-nav hero-nav--prev"
                onClick={() => sliderRef.current.slickPrev()}
                aria-label="اسلاید قبلی"
            >
                <FaArrowRight />
            </button>
            <button
                className="hero-nav hero-nav--next"
                onClick={() => sliderRef.current.slickNext()}
                aria-label="اسلاید بعدی"
            >
                <FaArrowLeft />
            </button>
        </div>
    );
}

export default Testimonials;
